import styled from 'styled-components'

const StyledLessonSidebarExpand = styled.button`
  bottom: 80px;
  height: 60px;
  border-radius: 20px 20px 0 0;
  padding: 20px;
  font-size: 15px;
  font-weight: 500;
  box-shadow: 0 0 10px rgb(0, 0, 0, 0.05);
  color: ${({ theme }) => theme.color.gray[700]};
  background-color: ${({ theme }) => theme.color.gray[200]};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 0;
  right: 0;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoint.s}px) {
    flex-shrink: 0;
    top: calc(70px + 14px);
    right: 14px;
    left: unset;
    padding: 0;
    box-shadow: unset;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.color.gray[200]}c4;
    color: ${({ theme }) => theme.color.gray[600]};

    svg {
      height: 24px;
    }
  }
`

export default StyledLessonSidebarExpand
